import styled from "styled-components";
import { Layout, Typography } from "antd";

const { Footer: AntFooter } = Layout;
const { Text, Link } = Typography;

export const StyledFooter = styled(AntFooter)`
  background: #001529;
  color: white;
  padding: 24px 50px;
`;

export const FooterLink = styled(Link)`
  color: #ccc;
  margin-right: 16px;

  &:last-child {
    margin-right: 0;
  }
`;

export const FooterText = styled(Text)`
  color: white;
`;
